import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAssetExposures } from "../../actions/assetDetailsActions";
import burgermenu from "../returnsandstatistics/images/burger-menu.svg";
import linechartup from "../returnsandstatistics/images/line-chart-up-01.svg";
import { getExposureAssetLevelChartAction } from "../../actions/privateExposureAction";
import { getPrivateExposureCategoryTypeDates } from "../../../config/apiConfig";
import {
  Chart,
  ChartLegend,
  ChartTitle,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartCategoryAxisTitle,
  ChartCategoryAxisLabels,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import moment from "moment";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import noDataAvailable from '../../../Images/noDataAvailable.svg';


export const AssetExposureList = (props) => {
  const view = props.view;

  const dispatch = useDispatch();
  const params = useParams();
    const [Loading, setLoading] = useState(true);
  const assetPrivateExposureSummaryData = useSelector(
    (state) => state.assetPrivateExposureSummary.assetPrivateExposureSummary
  );
  const exposureisloading = useSelector(
    (state) => state.assetPrivateExposureSummary.isLoading
  );
  useEffect(() => {
    dispatch(getAssetExposures(params.Asset));
  }, []);
    function PercentageDisplay({ value }) {
    const formattedValue = (value * 100).toFixed(0); // Convert to percentage and format with 2 decimal places
    return <span>{formattedValue}%</span>;
  }

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const areaChartType = "area";
  const columnChartType = "column";
  const lineChartType = "line";

  const AssetLevelChart = Gstate?.PrivateExposure?.AssetLevelChart || [];
  const assetLevelChartCategories =
    AssetLevelChart[0]?.ExposureDateString || [];

  const assetLevelChartStep =
    assetLevelChartCategories.length > 160
      ? 12
      : assetLevelChartCategories.length > 120
      ? 6
      : 0;
  const assetLevelChartData = Array.isArray(AssetLevelChart)
    ? AssetLevelChart.map((item) => ({
        name: item.ExposureCategory.replace(/Exposures?|Value/gi, ""),
        type:
          item.ExposureCategory.indexOf("Net") > 0
            ? lineChartType
            : areaChartType,
        data: item.NetValue,
        color: item.CategoryColor,
        visibleInLegend: item.ExposureCategory === "Hide" ? false : true,
      }))
        : [];
    

  return (
      <>
          {assetPrivateExposureSummaryData.length !== 0 ? (
              <div>
                  {view === "grid" && (
                      <div class="card-body">
                          {
                              assetPrivateExposureSummaryData.map((item) => (
                                  <>
                                      <div class="row p-3 border-bottom  m-0">
                                          <div class="col-6 left">
                                              <span>{item.ExposureType} Exp</span>
                                          </div>
                                          <div class="col-6 text-sm-end fw-medium">
                                              <span>
                                                  {item?.ExposureValue ? (
                                                      <PercentageDisplay value={item?.ExposureValue} />
                                                  ) : (
                                                      "NA"
                                                  )}
                                              </span>
                                          </div>
                                      </div>
                                  </>
                              ))
                          }
                      </div>
                  )}
                  {view === "chart" && (
                      <div class="card-body">
                          {exposureisloading ? (
                              <>
                                  <LoadingScreen />
                              </>
                          ) : (
                              <Chart style={{ height: "250px" }}>
                                  <ChartTitle />

                                  <ChartCategoryAxis>
                                      <ChartCategoryAxisItem
                                          categories={assetLevelChartCategories}
                                          labels={{
                                              step: assetLevelChartStep,
                                              rotation: 90,
                                              position: "start",
                                              font: "10px 'Arial'",
                                          }}
                                      />
                                  </ChartCategoryAxis>
                                  <ChartValueAxis>
                                      <ChartValueAxisItem
                                          name="primary"
                                          color="#7D7D7D"
                                          labels={{
                                              format: "{0}%",
                                              position: "right",
                                              font: "10px 'Arial'",
                                          }}
                                          majorGridLines={{ visible: false }}
                                      />
                                  </ChartValueAxis>
                                  <ChartSeries>
                                      {assetLevelChartData.map((series) => (
                                          <ChartSeriesItem
                                              key={series.name}
                                              type={series.type}
                                              data={series.data}
                                              name={series.name}
                                              color={series.color}
                                              tooltip={{ visible: true, format: "{0:N2}%" }}
                                              opacity={1}
                                              visibleInLegend={series.visibleInLegend}
                                          />
                                      ))}
                                  </ChartSeries>
                                  <ChartLegend position="bottom" visible={true} />
                              </Chart>
                          )}
                      </div>
                  )}
              </div>
          ) : (
              <div className='d-flex w-100 my-4 h-100'>
                  <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'} />
              </div>
          )}
          
   
    </>
  );
};
